import api from "./base-api"

const tohSyncConflictsApi = api.injectEndpoints({
    endpoints: (build) => ({
        getSyncConflictsTOH: build.query({
            query: ({ stateId, vendorId, page = 0, limit = 25 }) => {
                const p = new URLSearchParams({ page, limit })
                if (stateId && stateId.trim()) p.set("stateId", stateId.trim())
                if (vendorId && vendorId.trim()) p.set("vendorId", vendorId.trim())
                return `v3/toh/sync-conflicts?${p.toString()}`
            },
            providesTags: ["SyncConflictsTOH"]
        }),
        getSyncConflictTOH: build.query({
            query: (id) => `v3/toh/sync-conflicts/${id}`,
            providesTags: (_r, _e, id) => [{ type: "SyncConflictsTOH", id }]
        })
    }),
    overrideExisting: false
})

export const {
    useGetSyncConflictsTOHQuery,
    useGetSyncConflictTOHQuery
} = tohSyncConflictsApi
